export class SearchAnnounce {
    skip?: number;
    fromDate?: Date;
    dateuntill?: Date;
    limit?: number;
    barcode?: string;
    labId: string;
    projectId?: string;
}